module.exports = __webpack_public_path__ + "static/comp-09db95579496ccd875c59ac08f60ffec.svg";